import expense from '@/http/requests/expense'
import vendor from '@/http/requests/vendor'

export default {
  //Bi List
  fetchBiReportTableList({ commit }, data) {
    return new Promise((resolve, reject) => {
      expense
        .biReportExpensesList(data)
        .then(response => {
          commit('SET_EXPENSE_LIST', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //Expense Dashboard
  fetchExpenseListDashboard({ commit }, data) {
    return new Promise((resolve, reject) => {
      expense
        .expensesList(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_EXPENSE_LIST', response.data.data)
          } else {
            commit('SET_EXPENSE_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  fetchVendorList({ commit }, data = null) {
    return new Promise((resolve, reject) => {
      vendor
        .list(data)
        .then(response => {
          commit('SET_VENDOR_LIST', response.data.vendors)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //Expense General
  fetchExpenseList({ commit }, data) {
    return new Promise((resolve, reject) => {
      expense.search(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_EXPENSE_LIST', response.data.data)
          } else {
            commit('SET_EXPENSE_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  assignClient({ commit }, data) {
    return new Promise((resolve, reject) => {
      expense.assignClient(data)
        .then(response => {
          commit('UPDATE_EXPENSE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //BOTH
  updateVendorEmail({ commit }, data) {
    return new Promise((resolve, reject) => {
      expense
        .updateVendorEmail(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      expense
        .update(data)
        .then(response => {
          commit('UPDATE_EXPENSE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  clearExpenseList({ commit }, data) {
    commit('CLEAR_EXPENSE_LIST')
  }
}
